// Orchestrates PIN lock: checks status on mount, activates idle + visibility hooks

import { useEffect } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { useLockStore } from '@/stores/lockStore';
import { useIdleDetection } from '@/hooks/useIdleDetection';
import { useVisibilityLock } from '@/hooks/useVisibilityLock';
import { fetchPinStatus } from '@/features/settings/pin-api';

export function usePinLock() {
  const { isAuthenticated } = useAuth();
  const { setPinEnabled, pinEnabled } = useLockStore();

  // Check PIN status on app load
  useEffect(() => {
    if (!isAuthenticated) return;

    fetchPinStatus()
      .then((status) => {
        setPinEnabled(status.enabled);
      })
      .catch(() => {
        // If we can't check, assume no PIN
        setPinEnabled(false);
      });
  }, [isAuthenticated, setPinEnabled]);

  // Reset lock state on logout so next login re-checks PIN status
  useEffect(() => {
    if (!isAuthenticated) {
      if (pinEnabled) {
        setPinEnabled(false);
      }
      useLockStore.setState({ pinStatusChecked: false });
    }
  }, [isAuthenticated, pinEnabled, setPinEnabled]);

  // Activate idle detection and visibility lock
  useIdleDetection();
  useVisibilityLock();
}
